import React from 'react';
import { MapWorkout, MapCheckIn } from './GpxMap.types';

const ColorDot = ({ color }: { color: string }) => (
    <span
        className="size-3 shrink-0 rounded-full"
        style={{ backgroundColor: color }}
    />
);

interface GpxMapLegendProps {
    filteredCheckIns: MapCheckIn[];
    parsedWorkouts: MapWorkout[];
}

export const GpxMapLegend = ({
    filteredCheckIns,
    parsedWorkouts
}: GpxMapLegendProps) => {
    if (filteredCheckIns.length === 0 && parsedWorkouts.length === 0) {
        return null;
    }

    return (
        <div className="absolute top-2.5 right-2.5 max-h-[200px] min-w-[140px] overflow-auto rounded-md border border-white/10 bg-neutral-900/90 p-2 shadow-lg backdrop-blur">
            <ul className="flex flex-col gap-1">
                {parsedWorkouts.map((workout) => (
                    <li
                        key={workout.id}
                        className="flex items-center gap-2 text-sm text-white/90"
                    >
                        <ColorDot color={workout.color} />
                        {workout.type}
                    </li>
                ))}
                {filteredCheckIns.map((checkIn, index) => (
                    <li
                        key={checkIn.id || `checkin-${index}`}
                        className="flex items-center gap-2 text-sm text-white/90"
                    >
                        <ColorDot color={checkIn.color} />
                        {checkIn.name}
                    </li>
                ))}
            </ul>
        </div>
    );
};
